import { Collapse, Icon } from "@blueprintjs/core"
import { useState } from "react"
import { SCIENT_COLORS } from "../../../../../styled/scientColors"
import {
  CompanyName,
  CompanyRow,
  GroupCardContainer,
  GroupHeader,
  GroupName,
  GroupPercentage,
  GroupStats,
  GroupValue,
  PositionQuantity,
  PositionRow,
  PositionSymbol,
  PositionValue,
} from "../Factsheet.styled"
import { GroupedData } from "../types"
import { formatCurrency } from "../utils"

interface GroupCardProps {
  group: GroupedData
  currency?: string | null
}

const GroupCard = ({ group, currency }: GroupCardProps) => {
  const [expandedCompanies, setExpandedCompanies] = useState<Set<string>>(new Set())

  const toggleCompany = (companyName: string) => {
    setExpandedCompanies(prev => {
      const next = new Set(prev)
      if (next.has(companyName)) {
        next.delete(companyName)
      } else {
        next.add(companyName)
      }
      return next
    })
  }

  return (
    <GroupCardContainer>
      <GroupHeader alignItems="center">
        <GroupName>{group.name}</GroupName>
        <GroupStats>
          <GroupPercentage>{group.percentage.toFixed(1)}%</GroupPercentage>
          <GroupValue>{formatCurrency(group.totalExposure, currency)}</GroupValue>
        </GroupStats>
      </GroupHeader>

      {group.companies.map(company => (
        <div key={company.companyName}>
          <CompanyRow onClick={() => toggleCompany(company.companyName)} alignItems="center">
            <Icon
              icon={expandedCompanies.has(company.companyName) ? "chevron-down" : "chevron-right"}
              size={12}
              color={SCIENT_COLORS.gray3}
            />
            <CompanyName>{company.companyName}</CompanyName>
            <GroupPercentage>{company.percentage.toFixed(1)}%</GroupPercentage>
            <GroupValue>{formatCurrency(company.totalExposure, currency)}</GroupValue>
          </CompanyRow>

          <Collapse isOpen={expandedCompanies.has(company.companyName)}>
            {company.positions.map(pos => (
              <PositionRow key={pos.display_symbol} alignItems="center">
                <PositionSymbol>
                  {pos.display_symbol} ({pos.instrument_type})
                </PositionSymbol>
                <PositionQuantity>{pos.quantity}</PositionQuantity>
                <PositionValue>{formatCurrency(pos.market_exposure, currency)}</PositionValue>
              </PositionRow>
            ))}
          </Collapse>
        </div>
      ))}
    </GroupCardContainer>
  )
}

export default GroupCard
